import React, { useEffect } from 'react'
import { useState } from 'react'
import { Client, Databases, Query } from "appwrite";
import { Link } from 'react-router-dom';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import Blog from './web_blogs.js/backend-of-website';
import image from './logo.png'

export const metadata = {
    title: "..."
}

const client = new Client();

client
    .setEndpoint('https://cloud.appwrite.io/v1')
    .setProject('65a105b7ac26a63b4779');



const BlogPost = ({ title, content, imageSrc, action }) => (
    <div
        style={{
            width: '300px',
            padding: '15px',
            borderRadius: '8px',
            boxShadow: '0 4px 8px rgba(0, 0, 0, 0.1)',
            transition: 'transform 0.3s ease-in-out',
            margin: '0 0 20px 0',
        }}
        onMouseOver={(e) => e.currentTarget.style.transform = 'translateY(-5px)'}
        onMouseOut={(e) => e.currentTarget.style.transform = 'translateY(0)'}
    >
        <img
            src={imageSrc}
            alt={`Blog Image - ${title}`}
            style={{
                width: '100%',
                height: '150px',
                borderRadius: '8px 8px 0 0',
            }}
        />
        <h2
            style={{
                fontSize: '1.2em',
                fontWeight: 'bold',
                height: '40px'
            }}
        >
            {title}
        </h2>
        <p
            style={{
                color: '#666',
            }}
        >
            {content}
        </p>
        <div
            style={{
                content: '',
                display: 'block',
                height: '1px',
                backgroundColor: '#ddd',
                marginTop: '10px',
            }}
        />
        <Link to={action} style={{ textDecoration: 'none', color: 'inherit' }}>
            <input type="submit" value="Check" style={{ backgroundColor: '#4CAF50', color: 'white', marginTop: '10px', padding: '10px', border: 'none', borderRadius: '4px', cursor: 'pointer', fontSize: '16px', }} />
        </Link>
    </div>
);

export default function Section() {

    const cardStyles = {
        maxWidth: '300px',
        margin: '20px auto',
        backgroundColor: '#fff',
        borderRadius: '8px',
        boxShadow: '0 4px 8px rgba(0, 0, 0, 0.1)',
        overflow: 'hidden',
    };

    const imageStyles = {
        width: '100%',
        height: '300px',
        objectFit: 'contain',
        borderBottom: '1px solid #ddd',
    };

    const contentStyles = {
        padding: '20px',
    };

    const titleStyles = {
        color: '#333',
        marginBottom: '10px',
    };

    const textStyles = {
        color: '#666',
        lineHeight: '1.6',
    };

    const linkStyles = {
        display: 'block',
        textDecoration: 'none',
        color: '#007bff',
        marginTop: '10px',
    };
    let [set, newset] = useState([])
    let [now, after] = useState([])
    let [now2, after2] = useState([])
    let [now3, after3] = useState([])
    const databases = new Databases(client);

    let promise = databases.listDocuments(
        "65a106540e177077ef01",
        "65a10663880b2fdd291f",
    );
    promise.then(function (response) {
        newset(response.documents)
        let lastIndex = response.documents.length - 1;
        let lastObject = response.documents[lastIndex];
        let lastIndex2 = response.documents.length - 2;
        let lastObject2 = response.documents[lastIndex2]
        let lastIndex3 = response.documents.length - 3;
        let lastObject3 = response.documents[lastIndex3]
        after(lastObject)
        after2(lastObject2)
        after3(lastObject3)
    }, function (error) {
        console.log(error);
    });
    return (
        <>
            <div className="container"><br /><br />
                <div className="featured">
                    <h1 style={{ fontFamily: 'Times New Roman', WebkitTextStroke: '2px', textShadow: '0px 0px 20px orange' }}>Featured Posts</h1><br /><br />
                    <div className="card"><br /><br /><br />
                        <h2 style={{ fontFamily: 'Times New Roman' }}>How to become a successful Web developer</h2><br /><br /><br />
                        <p style={{ fontFamily: 'Times New Roman', fontWeight: 'lighter', fontSize: '17px', textAlign: 'center', margin: '0px 20px' }}>Embark on the journey to become a successful web developer. Master HTML, CSS, and JavaScript fundamentals, explore popular frameworks, and learn version control with Git. Stay informed about the latest trends, and build an impressive portfolio. Your guide to excelling in the dynamic world of web development.</p><br />
                        <div className="button_container" style={{ display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                            <a href="success"><button type="button" class="btn btn-success" style={{ height: '40px', width: '100px' }}>Check</button></a>
                            <button type='button' className='btn btn-primary' style={{ height: '40px', width: '100px', marginLeft: '100px' }}>More...</button>
                        </div>
                    </div>
                </div>
            </div><br /><br /><br /><br />
            <div className="container">
                <h1 style={{ fontFamily: 'Times New Roman', WebkitTextStroke: '2px', textShadow: '0px 0px 20px orange' }}>New Posts</h1><br /><br />
                <div className="recent">
                    <div style={cardStyles}>
                        <img src={now2.Image} alt="Card Image" style={imageStyles} />
                        <div style={contentStyles}>
                            <h2 style={titleStyles}>{now2.Title}</h2>
                            <p style={textStyles}>
                                {now2.metadesc}
                            </p>
                            <a href={now2.slug} style={linkStyles}>
                                Read More
                            </a>
                        </div>
                    </div>
                    <div style={cardStyles}>
                        <img src={now3.Image} alt="Card Image" style={imageStyles} />
                        <div style={contentStyles}>
                            <h2 style={titleStyles}>{now3.Title}</h2>
                            <p style={textStyles}>
                                {now3.metadesc}
                            </p>
                            <a href={now3.slug} style={linkStyles}>
                                Read More
                            </a>
                        </div>
                    </div>
                    <div style={cardStyles}>
                        <img src={now.Image} alt="Card Image" style={imageStyles} />
                        <div style={contentStyles}>
                            <h2 style={titleStyles}>{now.Title}</h2>
                            <p style={textStyles}>
                                {now.metadesc}
                            </p>
                            <a href={now.slug} style={linkStyles}>
                                Read More
                            </a>
                        </div>
                    </div>
                </div>
            </div>
            <div className="blogs">
                <h1 style={{ marginTop: '20px', fontFamily: 'Times New Roman', WebkitTextStroke: '2px', textAlign: 'center' }}>All Blogs</h1>
            </div><br /><br />
            <div className="container" style={{ display: 'flex', flexWrap: 'wrap', gap: '20px', }}>
                {set.map((post) => (
                    <BlogPost
                        key={post.id}
                        title={post.Title}
                        content={post.metadesc}
                        imageSrc={post.Image}
                        action={post.slug}
                    />))}
            </div>
        </>
    )
}